import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "default-content" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "pager" }
const _hoisted_5 = { class: "transfer" }
const _hoisted_6 = { class: "transfer" }
const _hoisted_7 = { class: "new-option" }
const _hoisted_8 = {
  class: "options-list",
  id: "optionsList",
  ref: "optionsList"
}
const _hoisted_9 = { class: "option-button" }
const _hoisted_10 = ["id"]
const _hoisted_11 = {
  key: 0,
  class: "count"
}
const _hoisted_12 = { class: "upload" }

export function render(_ctx, _cache) {
  const _component_Header = _resolveComponent("Header")
  const _component_Navigation = _resolveComponent("Navigation")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _component_Plus = _resolveComponent("Plus")
  const _component_el_icon = _resolveComponent("el-icon")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_col = _resolveComponent("el-col")
  const _component_Minus = _resolveComponent("Minus")
  const _component_el_row = _resolveComponent("el-row")
  const _component_WarningFilled = _resolveComponent("WarningFilled")
  const _component_ChatLineRound = _resolveComponent("ChatLineRound")
  const _component_Memo = _resolveComponent("Memo")
  const _component_Compass = _resolveComponent("Compass")
  const _component_DocumentCopy = _resolveComponent("DocumentCopy")
  const _component_Close = _resolveComponent("Close")
  const _component_Check = _resolveComponent("Check")
  const _component_Delete = _resolveComponent("Delete")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_transfer = _resolveComponent("el-transfer")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_rate = _resolveComponent("el-rate")
  const _component_el_switch = _resolveComponent("el-switch")
  const _component_Collection = _resolveComponent("Collection")
  const _component_ArrowRightBold = _resolveComponent("ArrowRightBold")
  const _component_ArrowLeftBold = _resolveComponent("ArrowLeftBold")
  const _component_UploadFilled = _resolveComponent("UploadFilled")
  const _component_el_upload = _resolveComponent("el-upload")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header, {
      windowWidth: _ctx.windowWidth,
      windowHeight: _ctx.windowHeight
    }, null, 8, ["windowWidth", "windowHeight"]),
    _createVNode(_component_Navigation, {
      activeMenu: _ctx.NavigationIndex.QUESTION,
      windowWidth: _ctx.windowWidth,
      windowHeight: _ctx.windowHeight
    }, null, 8, ["activeMenu", "windowWidth", "windowHeight"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_main, null, {
              default: _withCtx(() => _cache[17] || (_cache[17] = [
                _createElementVNode("div", { class: "danger" }, [
                  _createElementVNode("h4", null, "Zugang verweigert."),
                  _createElementVNode("p", null, "Sie besitzen nicht die erforderliche Berechtigung für diesen Bereich.")
                ], -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, !_ctx.hasPermission['QSTN_SELECT'] && !_ctx.loading]
        ]),
        _withDirectives(_createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_main, { class: "rounded-content" }, {
              default: _withCtx(() => [
                (_ctx.hasPermission['QSTN_INSERT'])
                  ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "primary",
                      onClick: _cache[0] || (_cache[0] = $event => (_ctx.onNewQuestionClick()))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, { size: 16 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Plus)
                          ]),
                          _: 1
                        }),
                        _cache[18] || (_cache[18] = _createTextVNode(" Neue Frage "))
                      ]),
                      _: 1
                    }, 512)), [
                      [_vShow, !_ctx.insertMode]
                    ])
                  : _createCommentVNode("", true),
                (_ctx.hasPermission['QSTN_INSERT'])
                  ? (_openBlock(), _createElementBlock("hr", _hoisted_3))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.filter,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.filter) = $event)),
                  placeholder: "Filter",
                  onInput: _ctx.onFilterChange,
                  clearable: ""
                }, null, 8, ["modelValue", "onInput"]),
                _withDirectives((_openBlock(), _createBlock(_component_el_table, { data: _ctx.displayList }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      prop: "position",
                      label: "Nr.",
                      width: "80"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.displayList[scope.$index].position,
                          "onUpdate:modelValue": $event => ((_ctx.displayList[scope.$index].position) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "sourceid",
                      label: "Quelle",
                      width: "130px"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.displayList[scope.$index].sourceid,
                          "onUpdate:modelValue": $event => ((_ctx.displayList[scope.$index].sourceid) = $event)
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sourceModelList, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.sourceid,
                                label: item.name,
                                value: item.sourceid
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "question",
                      label: "Frage"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, {
                              span: _ctx.showSingleChoiceQuestion ? 10 : 22
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.displayList[scope.$index].question,
                                  "onUpdate:modelValue": $event => ((_ctx.displayList[scope.$index].question) = $event),
                                  onKeyup: _withKeys($event => (_ctx.onQuestionSaveClick(_ctx.displayList[scope.$index])), ["enter"])
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup"])
                              ]),
                              _: 2
                            }, 1032, ["span"]),
                            _createVNode(_component_el_col, {
                              span: 2,
                              align: "center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_button, {
                                  type: "default",
                                  onClick: _cache[2] || (_cache[2] = $event => (_ctx.onShowSingleChoiceClick())),
                                  circle: ""
                                }, {
                                  default: _withCtx(() => [
                                    (_ctx.showSingleChoiceQuestion)
                                      ? (_openBlock(), _createBlock(_component_el_icon, {
                                          key: 0,
                                          size: 16
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_Minus)
                                          ]),
                                          _: 1
                                        }))
                                      : (_openBlock(), _createBlock(_component_el_icon, {
                                          key: 1,
                                          size: 16
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_Plus)
                                          ]),
                                          _: 1
                                        }))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            (_ctx.showSingleChoiceQuestion)
                              ? (_openBlock(), _createBlock(_component_el_col, {
                                  key: 0,
                                  span: 12
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.displayList[scope.$index].singlechoice,
                                      "onUpdate:modelValue": $event => ((_ctx.displayList[scope.$index].singlechoice) = $event),
                                      onKeyup: _withKeys($event => (_ctx.onQuestionSaveClick(_ctx.displayList[scope.$index])), ["enter"])
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup"])
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "dateupdate",
                      label: "Erstellt am",
                      width: "160"
                    }, {
                      default: _withCtx((scope) => [
                        _createTextVNode(_toDisplayString(new Intl.DateTimeFormat('de-DE', {year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'}).format(new Date(0).setUTCSeconds(_ctx.displayList[scope.$index].dateupdate))), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "",
                      width: "40"
                    }, {
                      default: _withCtx((scope) => [
                        (_ctx.displayList[scope.$index].incorrect < 4)
                          ? (_openBlock(), _createBlock(_component_el_icon, {
                              key: 0,
                              size: 28,
                              class: "warn",
                              title: "Zu wenige inkorrekte Antwortmöglichkeiten"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_WarningFilled)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    (_ctx.hasPermission['QSTN_UPDATE'])
                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                          key: 0,
                          fixed: "right",
                          label: "",
                          width: "60"
                        }, {
                          default: _withCtx((scope) => [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: $event => (_ctx.onOptionsEditClick(_ctx.displayList[scope.$index])),
                              circle: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, { size: 16 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ChatLineRound)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.hasPermission['QSTN_UPDATE'])
                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                          key: 1,
                          fixed: "right",
                          label: "",
                          width: "60"
                        }, {
                          default: _withCtx((scope) => [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: $event => (_ctx.onCategoryEditClick(_ctx.displayList[scope.$index])),
                              circle: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, { size: 16 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Memo)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.hasPermission['QSTN_UPDATE'])
                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                          key: 2,
                          fixed: "right",
                          label: "",
                          width: "60"
                        }, {
                          default: _withCtx((scope) => [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: $event => (_ctx.onTargetgroupEditClick(_ctx.displayList[scope.$index])),
                              circle: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, { size: 16 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Compass)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.hasPermission['QSTN_UPDATE'])
                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                          key: 3,
                          fixed: "right",
                          label: "",
                          width: "60"
                        }, {
                          default: _withCtx((scope) => [
                            (!_ctx.copyMode)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 0,
                                  type: "primary",
                                  onClick: $event => (_ctx.onCopyOptionsClick(_ctx.displayList[scope.$index])),
                                  circle: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_icon, { size: 16 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_DocumentCopy)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : _createCommentVNode("", true),
                            (_ctx.copyMode && _ctx.copyQuestion == _ctx.displayList[scope.$index])
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 1,
                                  type: "danger",
                                  onClick: _ctx.onCancelCopyOptionsClick,
                                  circle: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_icon, { size: 16 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Close)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]))
                              : _createCommentVNode("", true),
                            (_ctx.copyMode && _ctx.copyQuestion != _ctx.displayList[scope.$index])
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 2,
                                  type: "success",
                                  onClick: $event => (_ctx.onConfirmCopyOptionsClick(_ctx.displayList[scope.$index])),
                                  circle: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_icon, { size: 16 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Plus)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.hasPermission['QSTN_UPDATE'])
                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                          key: 4,
                          fixed: "right",
                          label: "",
                          width: "60"
                        }, {
                          default: _withCtx((scope) => [
                            _createVNode(_component_el_button, {
                              type: "success",
                              onClick: $event => (_ctx.onQuestionSaveClick(_ctx.displayList[scope.$index])),
                              circle: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, { size: 16 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Check)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.hasPermission['QSTN_DELETE'])
                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                          key: 5,
                          fixed: "right",
                          label: "",
                          width: "60"
                        }, {
                          default: _withCtx((scope) => [
                            _createVNode(_component_el_button, {
                              type: "danger",
                              onClick: $event => (_ctx.onQuestionDeleteClick(_ctx.displayList[scope.$index])),
                              circle: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, { size: 16 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Delete)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["data"])), [
                  [_directive_loading, _ctx.loading]
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_el_pagination, {
                    background: "",
                    layout: "prev, pager, next, jumper",
                    total: _ctx.filteredList.length,
                    pageSize: _ctx.rowsPerPage,
                    pagerCount: _ctx.pagerCount,
                    currentPage: _ctx.page,
                    onCurrentChange: _ctx.onPageChange
                  }, null, 8, ["total", "pageSize", "pagerCount", "currentPage", "onCurrentChange"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.hasPermission['QSTN_SELECT']]
        ])
      ]),
      _createVNode(_component_el_dialog, {
        title: "Kategorien",
        modelValue: _ctx.showCategories,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.showCategories) = $event)),
        center: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_transfer, {
              modelValue: _ctx.selectedCategories,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.selectedCategories) = $event)),
              titles: ['Verfügbar', 'Zugeordnet'],
              data: _ctx.availableCategories,
              onChange: _ctx.onCategoryChange
            }, null, 8, ["modelValue", "data", "onChange"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        title: _ctx.currentQuestion ? ('Zielgruppen für: ' + _ctx.currentQuestion.question) : 'Zielgruppen',
        modelValue: _ctx.showTargetgroups,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.showTargetgroups) = $event)),
        center: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_transfer, {
              modelValue: _ctx.selectedTargetgroups,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.selectedTargetgroups) = $event)),
              titles: ['Verfügbar', 'Zugeordnet'],
              data: _ctx.availableTargetgroups,
              onChange: _ctx.onTargetgroupChange
            }, null, 8, ["modelValue", "data", "onChange"])
          ])
        ]),
        _: 1
      }, 8, ["title", "modelValue"]),
      _createVNode(_component_el_dialog, {
        title: _ctx.questName,
        modelValue: _ctx.showOptions,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => ((_ctx.showOptions) = $event)),
        width: "90%",
        top: "10px",
        onOpened: _ctx.onOptionDialogOpened
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_el_form, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, { gutter: 20 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 20 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "Neue Option",
                          prop: "option"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.newOptionModel.option,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.newOptionModel.option) = $event)),
                              onKeyup: _withKeys(_ctx.onNewOptionClick, ["enter"]),
                              onInput: _ctx.onOptionInput
                            }, null, 8, ["modelValue", "onKeyup", "onInput"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 2 }, {
                      default: _withCtx(() => [
                        _withDirectives(_createVNode(_component_el_button, {
                          type: "primary",
                          disabled: !_ctx.optionFormValid,
                          onClick: _ctx.onNewOptionClick
                        }, {
                          default: _withCtx(() => _cache[19] || (_cache[19] = [
                            _createTextVNode("Hinzufügen")
                          ])),
                          _: 1
                        }, 8, ["disabled", "onClick"]), [
                          [_vShow, _ctx.dragId == 0]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, {
                      span: 17,
                      class: "filter-col"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "Filter",
                          prop: "option"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.optionFilter,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((_ctx.optionFilter) = $event)),
                              onInput: _ctx.onOptionFilterInput,
                              clearable: ""
                            }, null, 8, ["modelValue", "onInput"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 4 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "Sortierung" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.sortBy,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((_ctx.sortBy) = $event)),
                              onChange: _ctx.onSortingChange
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_option, {
                                  key: "position",
                                  label: "Nummer",
                                  value: "position"
                                }),
                                _createVNode(_component_el_option, {
                                  key: "option",
                                  label: "Antwort",
                                  value: "option"
                                }),
                                _createVNode(_component_el_option, {
                                  key: "difficulty",
                                  label: "Schwierigkeit",
                                  value: "difficulty"
                                }),
                                _createVNode(_component_el_option, {
                                  key: "iscorrect",
                                  label: "Richtigkeit",
                                  value: "iscorrect"
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _withDirectives(_createVNode(_component_el_form_item, { prop: "position" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      disabled: true,
                      modelValue: _ctx.newOptionModel.position,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => ((_ctx.newOptionModel.position) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, false]
                ])
              ]),
              _: 1
            })
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionModelList, (option) => {
              return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", {
                  id: option.optionid,
                  class: "drag"
                }, [
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, {
                        span: 0.5,
                        class: "option-position",
                        onClick: $event => (_ctx.onOptionPositionClick(option))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(option.position), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_component_el_col, { span: 15 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            class: "option-edit",
                            modelValue: option.option,
                            "onUpdate:modelValue": $event => ((option.option) = $event),
                            onKeyup: _withKeys($event => (_ctx.onOptionSaveClick(option)), ["enter"])
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_col, {
                        span: 4,
                        class: "rating"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_rate, {
                            modelValue: option.difficulty,
                            "onUpdate:modelValue": $event => ((option.difficulty) = $event),
                            max: 5,
                            texts: _ctx.ratingTexts,
                            colors: _ctx.ratingColors,
                            "void-color": "#000000",
                            "show-text": "",
                            onChange: $event => (_ctx.onOptionDifficultyChange(option))
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "texts", "colors", "onChange"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_col, { span: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_switch, {
                            modelValue: option.iscorrect,
                            "onUpdate:modelValue": $event => ((option.iscorrect) = $event),
                            onChange: $event => (_ctx.onOptionCorrectChange(option))
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_col, {
                        span: 0.5,
                        class: "icon-col"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: $event => (_ctx.onOptionReferenceClick(option)),
                            circle: ""
                          }, {
                            default: _withCtx(() => [
                              (option.reference_count > 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(option.reference_count), 1))
                                : (_openBlock(), _createBlock(_component_el_icon, {
                                    key: 1,
                                    size: 16
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Collection)
                                    ]),
                                    _: 1
                                  }))
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_col, {
                        span: 0.5,
                        class: "icon-col"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            type: "success",
                            onClick: $event => (_ctx.onOptionSaveClick(option)),
                            circle: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_icon, { size: 16 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Check)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_col, { span: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            type: "danger",
                            onClick: $event => (_ctx.deleteOption(option)),
                            circle: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_icon, { size: 16 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Delete)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ], 8, _hoisted_10)
              ], 512)), [
                [_vShow, !_ctx.loadOptions]
              ])
            }), 256))
          ])), [
            [_directive_loading, _ctx.loadOptions]
          ])
        ]),
        _: 1
      }, 8, ["title", "modelValue", "onOpened"]),
      _createVNode(_component_el_dialog, {
        title: _ctx.selectedReferenceText,
        modelValue: _ctx.showReferences,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => ((_ctx.showReferences) = $event)),
        width: "90%",
        top: "100px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, {
            gutter: 10,
            class: "reference-edit"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.filterReference,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => ((_ctx.filterReference) = $event)),
                    placeholder: "Filter",
                    onInput: _ctx.onReferenceFilterChange,
                    clearable: ""
                  }, null, 8, ["modelValue", "onInput"]),
                  _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                    data: _ctx.filteredReferenceList,
                    class: "table-bordered"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        label: "",
                        width: "60"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("sub", null, _toDisplayString(_ctx.filteredReferenceList[scope.$index].referenceid), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, { label: "Verfügbare Referenzen" }, {
                        default: _withCtx((scope) => [
                          _createTextVNode(_toDisplayString(_ctx.filteredReferenceList[scope.$index].title.substring(0,45) + (_ctx.filteredReferenceList[scope.$index].title.length > 45 ? '...' : '')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        fixed: "right",
                        label: "",
                        width: "60"
                      }, {
                        default: _withCtx((scope) => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: $event => (_ctx.onAddReferenceClick(_ctx.filteredReferenceList[scope.$index])),
                            circle: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_icon, { size: 16 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ArrowRightBold)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["data"])), [
                    [_directive_loading, _ctx.loading]
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    class: "paste-button",
                    type: "success",
                    onClick: _ctx.onReferencePasteClick,
                    disabled: _ctx.copyReference == null || _ctx.isAssigned()
                  }, {
                    default: _withCtx(() => _cache[20] || (_cache[20] = [
                      _createTextVNode("Aus Zwischenablage einfügen")
                    ])),
                    _: 1
                  }, 8, ["onClick", "disabled"]),
                  _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                    data: _ctx.selectedReferencesList,
                    class: "table-right",
                    "highlight-current-row": "",
                    onCurrentChange: _ctx.onReferenceSelect
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        fixed: "left",
                        label: "",
                        width: "60"
                      }, {
                        default: _withCtx((scope) => [
                          _createVNode(_component_el_button, {
                            type: "danger",
                            onClick: $event => (_ctx.onRemoveReferenceClick(_ctx.selectedReferencesList[scope.$index])),
                            circle: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_icon, { size: 16 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ArrowLeftBold)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "",
                        width: "60"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("sub", null, _toDisplayString(_ctx.selectedReferencesList[scope.$index].referenceid), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, { label: "Ausgewählte Referenzen" }, {
                        default: _withCtx((scope) => [
                          _createTextVNode(_toDisplayString(_ctx.selectedReferencesList[scope.$index].title.substring(0,40) + (_ctx.selectedReferencesList[scope.$index].title.length > 40 ? '...' : '')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["data", "onCurrentChange"])), [
                    [_directive_loading, _ctx.loadingSelectedReferences]
                  ])
                ]),
                _: 1
              }),
              (_ctx.currentOptionReference && _ctx.currentOptionReference.referenceid > 0)
                ? (_openBlock(), _createBlock(_component_el_col, {
                    key: 0,
                    class: "infos",
                    span: 8
                  }, {
                    default: _withCtx(() => [
                      _cache[23] || (_cache[23] = _createElementVNode("div", { class: "infos-header" }, "Infos zur Referenz", -1)),
                      _createVNode(_component_el_row, { gutter: 10 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                class: "save-button",
                                type: "primary",
                                onClick: _ctx.onReferenceSaveClick
                              }, {
                                default: _withCtx(() => _cache[21] || (_cache[21] = [
                                  _createTextVNode("Speichern")
                                ])),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                class: "copy-button",
                                type: "success",
                                onClick: _ctx.onReferenceCopyClick,
                                disabled: _ctx.copyReference && _ctx.copyReference.optionid == _ctx.currentOptionReference.optionid && _ctx.copyReference.referenceid == _ctx.currentOptionReference.referenceid
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.copyReference && _ctx.copyReference.optionid == _ctx.currentOptionReference.optionid && _ctx.copyReference.referenceid == _ctx.currentOptionReference.referenceid ? 'in Zwischenablage' : 'Kopieren'), 1)
                                ]),
                                _: 1
                              }, 8, ["onClick", "disabled"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _cache[24] || (_cache[24] = _createElementVNode("div", { class: "info-field" }, "URL", -1)),
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.currentOptionReference.url,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => ((_ctx.currentOptionReference.url) = $event))
                      }, null, 8, ["modelValue"]),
                      _cache[25] || (_cache[25] = _createElementVNode("div", { class: "info-field" }, "Anmerkungen", -1)),
                      _createVNode(_component_el_input, {
                        type: "textarea",
                        rows: 10,
                        modelValue: _ctx.currentOptionReference.info,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => ((_ctx.currentOptionReference.info) = $event))
                      }, null, 8, ["modelValue"]),
                      _cache[26] || (_cache[26] = _createElementVNode("div", { class: "info-field" }, "Anhänge", -1)),
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_el_upload, {
                          "file-list": _ctx.fileList,
                          "onUpdate:fileList": _cache[15] || (_cache[15] = $event => ((_ctx.fileList) = $event)),
                          action: _ctx.uploadURL,
                          multiple: "",
                          "with-credentials": true,
                          "on-preview": _ctx.onFilePreview,
                          "on-remove": _ctx.onFileRemove,
                          "before-remove": _ctx.onFileBeforeRemove,
                          "on-success": _ctx.onFileSuccess,
                          limit: 10
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, {
                              size:  (_ctx.fileList && _ctx.fileList.length > 0) ? 40 : 130
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_UploadFilled)
                              ]),
                              _: 1
                            }, 8, ["size"]),
                            _cache[22] || (_cache[22] = _createElementVNode("div", { class: "tip" }, " Hier klicken, um neue Dateien hochzuladen. ", -1))
                          ]),
                          _: 1
                        }, 8, ["file-list", "action", "on-preview", "on-remove", "before-remove", "on-success"])
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["title", "modelValue"])
    ])
  ], 64))
}